














































import _ from 'lodash';
import { editFactory } from '@/main/pages';
import { SkladoveMistoPredmetu } from '@/modules/ciselnik/pujcovna/skladoveMistoPredmetu';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { SazbaDph } from '@/modules/ciselnik/firemni/dphsazba';
import { showNotification } from '@/main/utils/notifications';

import DmsDphCalculator from '#components/dms/dphCalculator/DmsDphCalculator.vue';

import { NAME } from './constants';
import { store } from './store/edit';
import { editMutations } from './store/types';

export default editFactory(NAME, store).extend({
	components: {
		SkladMistoPredmetuSelect: SkladoveMistoPredmetu.components.Select,
		DmsDphCalculator,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				skladMistoPredmetu: `${this.storeUri}/${editMutations.SKLAD_MISTO_PREDMETU_SELECT_MAPPER}`,
				nakladoveStredisko: `${this.storeUri}/${editMutations.NAKLAD_STREDISKO_SELECT_MAPPER}`,
			};
		},
		skladMistoPredmetuFilter(): { SkladostOzn: number | null, VyrazenPrp: boolean } {
			return {
				SkladostOzn: this.SkladostOzn,
				VyrazenPrp: false,
			};
		},
		dphSazba(): number {
			return (this.SazbyDph && this.DphSzbOzn && this.DphSzbOzn !== -1) ? this.SazbyDph[this.DphSzbOzn].DphSzb : 0;
		},
	},
	async created() {
		await this.getDphSazby();
	},
	methods: {
		async getDphSazby() {
			if (this.SazbyDph !== null) return;
			try {
				const result = await SazbaDph.apiProvider.tableData();
				const sazby = {};
				_.forEach(result.data, (dataRow) => {
					// TODO: type.
					(sazby as any)[dataRow.Cells[1]] = { // DphSzbOzn
						DphSzb: dataRow.Cells[3],
					};
				});
				this.SazbyDph = sazby;
			} catch (err) {
				showNotification({ title: err.name, message: err.message });
			}
		},
		provozovnaChange() {
			this.StrednaklOzn = null;
			this.StrednaklOznText = null;
			this.$nextTick(() => {
				(this as any).mainForm.clearValidate();
			});
		},
	},
});

